import React from 'react';
import { Star, Award, ShieldCheck, Medal, Briefcase, BadgeCheck, Handshake } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const BADGE_ICONS = { Award, ShieldCheck, Medal, Star, Briefcase, BadgeCheck, Handshake };

export function ReputationBadge({ level, levelInfo, avgRating, reviewCount, size = 'md' }) {
  const { language } = useLanguage();
  if (!levelInfo) return null;
  const label = levelInfo[language] || levelInfo.lv;
  const small = size === 'sm';

  return (
    <div className="inline-flex items-center gap-2" data-testid="reputation-badge">
      <span
        className={`inline-flex items-center gap-1 rounded-full font-semibold text-white ${small ? 'text-[11px] px-2 py-0.5' : 'text-xs px-3 py-1'}`}
        style={{ backgroundColor: levelInfo.color }}
      >
        <Medal className={small ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
        {language === 'lv' ? 'Līm.' : 'Lvl'} {level} · {label}
      </span>
      {reviewCount > 0 && (
        <span className={`inline-flex items-center gap-0.5 text-[#5C5C5C] ${small ? 'text-[11px]' : 'text-xs'}`}>
          <Star className={`${small ? 'w-3 h-3' : 'w-3.5 h-3.5'} fill-[#D97736] text-[#D97736]`} />
          {avgRating} ({reviewCount})
        </span>
      )}
    </div>
  );
}

export function BadgeChips({ badges }) {
  const { language } = useLanguage();
  if (!badges?.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="badge-chips">
      {badges.map((b) => {
        const Icon = BADGE_ICONS[b.icon] || Award;
        return (
          <span key={b.key} className="inline-flex items-center gap-1 bg-[#F3F2EE] text-[#121212] text-xs px-3 py-1.5 rounded-full" data-testid={`badge-${b.key}`}>
            <Icon className="w-3.5 h-3.5 text-[#D97736]" />
            {b[language] || b.lv}
          </span>
        );
      })}
    </div>
  );
}

// Prominent "Uzticams pārdevējs" pill — shown when a user has earned enough
// positive mutual reviews (≥5 reviews, avg ≥4.5★) to build buyer trust.
export function TrustedSellerBadge({ size = 'md', className = '' }) {
  const { language } = useLanguage();
  const small = size === 'sm';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold bg-[#E6F2F0] text-[#2F7E79] border border-[#C9E3DF] ${small ? 'text-[11px] px-2 py-0.5' : 'text-xs px-3 py-1'} ${className}`}
      data-testid="trusted-seller-badge"
    >
      <Handshake className={small ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
      {language === 'lv' ? 'Uzticams pārdevējs' : language === 'ru' ? 'Надёжный продавец' : 'Trusted seller'}
    </span>
  );
}